import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { TaskNewRoutingModule } from './task-new-routing.module';
import { TaskNewComponent } from './task-new.component';
import { SharedModule } from '../shared.module';
import { InfiniteScrollModule } from 'ngx-infinite-scroll';


@NgModule({
  declarations: [
    TaskNewComponent
  ],
  imports: [
    CommonModule,
    TaskNewRoutingModule,
    SharedModule,
    InfiniteScrollModule,
  ],exports:[
    TaskNewComponent
  ]
})
export class TaskNewModule { }
